import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { authRequestInterceptor } from 'api/axios/requests/interceptors/authRequestInterceptor';
import { useFederatedModule } from 'flop-module-federation/useFederatedModule';
import type { DashboardModule } from 'flop-module-federation/useDashboardModule'; // typeof the npm package exports
import { reactPlugin } from 'main/azureInsights/config';
import TitleWrapper from 'main/layout/TitleWrapper';
import { selectUser } from 'library/redux/application';
import { useAppSelector } from 'library/redux/hooks';

const FleetOperationsPage = (): React.JSX.Element => {

	const pcUser = useAppSelector(selectUser);
	// FLOP will fallback to English if particulate language not selected
	const pcUserLanguageCode = pcUser.language?.substring(0, 2);

	const { module: dashboard, loading, error } = useFederatedModule<DashboardModule>('vpc-dashboard');

	if (loading || !pcUser.id) return wrapTitle(<div>Loading dashboard…</div>);
	if (error || !dashboard) return wrapTitle(<div>Dashboard unavailable: {error?.message}</div>);

	const { PentaDashboard, FleetOperation, createDashboardClient } = dashboard;

	const client = createDashboardClient({
		apiHost: import.meta.env.VITE_PC_API_HOST,
		getToken: () => Promise.resolve(''), // Token is set in the interceptor
	});

	client.httpClient.instance.interceptors.request.use(authRequestInterceptor);

	return wrapTitle(
		<PentaDashboard client={client} language={pcUserLanguageCode ?? "en"}>
			<FleetOperation />
		</PentaDashboard>);

	function wrapTitle(content: React.ReactElement) {
		return <>
			<TitleWrapper
				category={'Fleet operations'}
				title={'Dashboard'} // TODO translation?

				displayBackButton={true}
			/>
			{content}
		</>
	}


};

export default withAITracking(
	reactPlugin,
	FleetOperationsPage,
	'FleetOperationsPage',
	'application-insight-container'
);
